import React from "react";
import CommonNavbar from "../components/CommonNavbar/CommonNavbar";
import FarmerShopHeroSec from "../components/AllProdutcs/FarmerShopHeroSec";
import ShopByCategory from "../components/HomePage/ShopByCategory";
import FarmShopBanner from "../components/AllProdutcs/FarmShopBanner";

import CommonFooter from "../components/CommonFooter/CommonFooter";
import Innovativetestimonials from "../components/innovativeFarmingSolutions/Innovativetestimonials";
import FarmerCityMart from "../components/AllProdutcs/FarmerCityMart";

const FarmerShop = () => {
  return (
    <div>
      <CommonNavbar hide_btn="d-none" show_btn="d-block" />
      {/* <FarmerShopHeroSec /> */}
     
      <div className="bg_clr_light_green px-2">
        < FarmerCityMart/>
      </div>
       <ShopByCategory />
       <Innovativetestimonials/>
      <CommonFooter />
    </div>
  );
};

export default FarmerShop;
